import { Typography } from "@mui/material";
import React from "react";
import styles from "./book-appointments.module.scss";

const BookAppointments = (): React.JSX.Element => (
  <div className={styles.bookAppointmentContainer}>
    <Typography variant="h6">Book an Appointment</Typography>
    {/* @todo book */}
  </div>
);

export default BookAppointments;
